import { OutreachCallStatus } from 'types/outreachCandidates.types';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, Clock, HelpCircle, PhoneMissed, XCircle } from 'lucide-react';

export const CallStatus = ({
  status,
  variant = 'badge',
}: {
  status?: OutreachCallStatus;
  variant?: 'badge' | 'card';
}) => {
  const getConfig = (status?: OutreachCallStatus) => {
    switch (status) {
      case OutreachCallStatus.SUCCESSFUL:
        return {
          label: 'Successful',
          badgeClassName: 'bg-green-100 text-green-700 hover:bg-green-100 capitalize',
          blockClassName: 'bg-green-50',
          iconClassName: 'text-green-600',
          icon: <CheckCircle className="h-5 w-5 text-green-600" />,
        };
      case OutreachCallStatus.NO_ANSWER:
        return {
          label: 'No Answer',
          badgeClassName: 'bg-yellow-100 text-yellow-700 hover:bg-yellow-100 capitalize',
          blockClassName: 'bg-yellow-50',
          iconClassName: 'text-yellow-600',
          icon: <PhoneMissed className="h-5 w-5 text-yellow-600" />,
        };
      case OutreachCallStatus.FAILED:
      case OutreachCallStatus.DECLINED:
      case OutreachCallStatus.CANCELED:
        return {
          label: status ? status.toLowerCase().replace(/_/g, ' ') : 'Failed',
          badgeClassName: 'bg-red-100 text-red-700 hover:bg-red-100 capitalize',
          blockClassName: 'bg-red-50',
          iconClassName: 'text-red-600',
          icon: <XCircle className="h-5 w-5 text-red-600" />,
        };
      case OutreachCallStatus.CREATED:
      case OutreachCallStatus.SCHEDULED:
      case OutreachCallStatus.RESCHEDULED:
      case undefined:
        return {
          label: status ? status.toLowerCase().replace(/_/g, ' ') : '-',
          badgeClassName: 'bg-blue-100 text-blue-700 hover:bg-blue-100 capitalize',
          blockClassName: 'bg-blue-50',
          iconClassName: 'text-blue-600',
          icon: <Clock className="h-5 w-5 text-blue-600" />,
        };
      default:
        status satisfies never; // For Agent - Do not comment out, handle missing status instead
        return {
          label: '-',
          badgeClassName: 'bg-gray-100 text-gray-700 hover:bg-gray-100',
          blockClassName: 'bg-gray-50',
          iconClassName: 'text-gray-600',
          icon: <HelpCircle className="h-5 w-5 text-gray-600" />,
        };
    }
  };

  const config = getConfig(status);

  if (variant === 'card') {
    return (
      <div className={`flex items-center justify-between rounded-lg p-3 ${config.blockClassName}`}>
        <span className="text-sm font-medium capitalize">{config.label}</span>
        {config.icon}
      </div>
    );
  }

  return <Badge className={config.badgeClassName}>{config.label}</Badge>;
};
